import type { TagProduct } from '~~/types/integrations/tagManager/TagProduct';
import type { EcommerceViewProduct } from '~~/types/integrations/tagManager/TagViewProduct';

export const buildViewProductTags = ({
  eventName,
  productTags,
  parentCategory,
}: {
  eventName: string;
  productTags: TagProduct;
  parentCategory: string;
}) => ({
  event: eventName,
  ecommerce: {
    detail: {
      actionField: {
        list: parentCategory,
      },
      products: [productTags],
    },
  } as EcommerceViewProduct,
});
